<app-user-slideout [loading]="loading" [user]="user">
  <div class="datagrid-title">{{ 'admin.userTable.headers.roles' | translate }}</div>
  <div class="datagrid-content">
    <ul class="list-group list-group-flush">
      @for (app of applications; track app) {
        <li class="list-group-item">
          <strong [innerHTML]="'apps.' + app.identifier | translate"></strong>
          <ul class="list-group list-group-flush">
            @for (role of app.roles; track role) {
              <li class="list-group-item">
                <span [appRoleNameTranslation]="role.name"></span>
              </li>
            }
          </ul>
        </li>
      }
    </ul>
  </div>
</app-user-slideout>